const doc = [({"da":({"js":({"admin":({"users":({"passwords":({"edit":({"change_your_password":"Skift din adgangskode"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;